import {ListViewSectionFilterLink} from '@github-ui/list-view/ListViewSectionFilterLink'
import {RepoStacksState} from '@github-ui/dotcom-schema/types/pull_requests/v1/repo_stacks'
import {useSearchParams} from '@github-ui/use-navigate'

import styles from './Stacks.module.css'

type StacksStateFiltersProps = {
  basePath: string
  state: RepoStacksState
  openCount: number
  completedCount: number
}

export function StacksStateFilters({basePath, state, openCount, completedCount}: StacksStateFiltersProps) {
  const [searchParams] = useSearchParams()

  const hrefFor = (nextState: 'open' | 'completed') => {
    const params = new URLSearchParams(searchParams)
    // A page from the other list could be out of range, so start from the first page.
    params.delete('page')
    if (nextState === 'completed') {
      params.set('state', 'completed')
    } else {
      params.delete('state')
    }
    const search = params.toString()
    return search ? `${basePath}?${search}` : basePath
  }

  return (
    <ul className={styles.stateFilters}>
      <li>
        <ListViewSectionFilterLink
          title="Open"
          count={openCount.toLocaleString('en-US')}
          isSelected={state !== RepoStacksState.COMPLETED}
          to={hrefFor('open')}
        />
      </li>
      <li>
        <ListViewSectionFilterLink
          title="Completed"
          count={completedCount.toLocaleString('en-US')}
          isSelected={state === RepoStacksState.COMPLETED}
          to={hrefFor('completed')}
        />
      </li>
    </ul>
  )
}
